import { organization as org } from '../organization/organization.reducers.js';

export const breadcrumbs = (state: $ElementType<ReduxState, 'breadcrumbs'> = []) => state;

export const organization = org;
export const organizationMenu = (state: $ElementType<ReduxState, 'organizationMenu'> = []) => state;
export const accessgroups = (state: $ElementType<ReduxState, 'accessgroups'> = {}) => state;
